interface JqModal {
	hide: ( cb?: Function ) => void;
	show: () => void;
	toggle: () => void;
}

export function JQModal( id: string ): JqModal {
	const m = window.$( "#" + id );
	return {
		hide: ( cb?: Function ) => {
			const callback = () => {
				cb?.();
				m.off( "hidden.bs.modal", callback );
			};
			cb && m.on( "hidden.bs.modal", callback );
			m.modal( "hide" );
		},
		show: () => m.modal( "show" ),
		toggle: () => m.modal( "toggle" ),
	};
}
